export default __webpack_public_path__ + "static/slack-c41494e8ea3e5e56faba3d75c855f1cb.svg";